import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { Space, Spin, Typography, message, theme } from 'antd';

import Configurazione from '../../Configurazione';
import { GetErrorMessage } from '../../Utility';
import stringres from '../../translations/stringres';
import '../Magazzino.css';

type ElencoQualitaCardProps = {
    idqualita: number;
    qualita: string;
    pezzi: number;
    hasImage: boolean;
    urlimmagine: string;
};

export default function ElencoQualitaCard(props: ElencoQualitaCardProps) {
    const { token } = theme.useToken();
    const [img, setImg] = useState(GetNoFoto());

    const [IsRunning, setisRunning] = useState(false);

    useEffect(() => {
        fetchFoto();
    }, [props]);

    function GetNoFoto(): string {
        return '../custom/no-imagelastre_300.png';
    }

    async function fetchFoto() {
        try {
            setisRunning(true);

            if (img !== GetNoFoto()) return;

            if (!props.hasImage) {
                setImg(GetNoFoto());
                return;
            }

            const res = await fetch(
                Configurazione().apiBaseUrl +
                    'Magazzino/StockQualitaImage?idsocieta=' +
                    Configurazione().idsocieta +
                    '&idQualita=' +
                    props.idqualita
            );

            if (res.status === 200) {
                const imageBlob = await res.blob();
                const imageObjectURL = URL.createObjectURL(imageBlob);

                if (imageObjectURL) setImg(imageObjectURL);
                else setImg(GetNoFoto());
            } else setImg(GetNoFoto());
        } catch (error) {
            message.error(GetErrorMessage(error));
        } finally {
            setisRunning(false);
        }
    }

    return (
        <div>
            <div style={{ margin: '5px' }}>
                <Spin spinning={IsRunning}>
                    <Link to={{ pathname: '/Magazzino', search: '?iq=' + props.idqualita }}>
                        <img className="imagegallery" src={img} alt=""></img>
                    </Link>
                    <div>
                        <Space direction="horizontal">
                            <Typography.Text>
                                <span style={{ color: token.colorPrimary }}>{props.qualita}</span>
                            </Typography.Text>
                            <Typography.Text style={{ fontSize: '5' }}>
                                {'(' + stringres.t('Pezzi') + ' ' + props.pezzi + ')'}
                            </Typography.Text>
                        </Space>
                    </div>
                </Spin>
            </div>
        </div>
    );
}
